module.exports = __webpack_public_path__ + "img/loading-gray.074556ea.svg";